import React from "react";
import Title from "./Title";
import Content from "./Content";
import { PageContentWrapper } from "../../shared/styled/PageContentStyle";

const OutsourceOrder = () => {
    return (
        <PageContentWrapper>
            <Title />
            <Content />
        </PageContentWrapper>
    );
};

export default OutsourceOrder;
